// React/finance-app/src/features/tt-insights/services.js
import api from '../../api';

export const getMonthlyLeaderboard = () =>
  api.get('/api/tt-insights/monthly-leaderboard');

export const getAllUsersCurWeekRebates = () =>
  api.get('/api/tt-insights/all-users-cur-week-rebates');

export const getRebates = (params) =>
  api.get('/api/tt-insights/rebates', { params });

export const getSummary = (user_code) =>
  api.get('/api/tt-insights/summary', { params: { user_code } });

export const getKpiState = (user_code) =>
  api.get('/api/tt-insights/kpi/state', { params: { user_code } });

export const getNotificationsHistory = (user_code, limit = 10) =>
  api.get('/api/tt-insights/notifications/history', { params: { user_code, limit } });

export const getTopBuyersMonth = () =>
  api.get('/api/tt-insights/analytics/top-buyers-month');

export const getAvailableBalances = () =>
  api.get('/api/tt-insights/analytics/available-balances');

export const getUserBalance = (user_code) =>
  api.get(`/api/tt-insights/analytics/user-balance/${encodeURIComponent(user_code)}`);

export const getNewModelMetrics = (user_code) =>
  api.get('/api/tt-insights/new-model/metrics', { params: { user_code } });